(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Background / looping videos.
     iOS Safari checks the muted *attribute* before allowing autoplay, so set it explicitly.
     The wrapper fades in once the first frame is decoded, and videos pause while off screen. */
  const videos = [...document.querySelectorAll('[data-autoplay-video] video')];

  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.loop = true;
    video.removeAttribute('controls');

    const wrapper = video.closest('[data-autoplay-video]');
    const markReady = () => wrapper.classList.add('is-ready');
    if (video.readyState >= 2) markReady();
    else video.addEventListener('loadeddata', markReady, { once: true });

    if (reduceMotion.matches) {
      video.pause();
      video.removeAttribute('autoplay');
      markReady();
    }
  });

  const play = (video) => {
    if (reduceMotion.matches) return;
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
  };

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting }) => (isIntersecting ? play(target) : target.pause()));
      },
      { threshold: 0.05 }
    );
    videos.forEach((video) => videoObserver.observe(video));
  } else {
    videos.forEach(play);
  }

  // Low Power Mode on iOS blocks autoplay: start on the first touch instead.
  const kickstart = () => videos.forEach((video) => video.paused && play(video));
  document.addEventListener('touchstart', kickstart, { once: true, passive: true });
  document.addEventListener('pointerdown', kickstart, { once: true });

  /* Header turns glassy once the visitor scrolls past the top of the hero. */
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const update = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* Gentle fade-up for sections as they enter the viewport. */
  const revealables = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduceMotion.matches) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    revealables.forEach((el) => revealObserver.observe(el));
  } else {
    revealables.forEach((el) => el.classList.add('is-visible'));
  }

  // The theme editor re-renders sections in place: re-run reveal so edited sections show up.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
    event.target.querySelectorAll('[data-autoplay-video]').forEach((wrapper) => wrapper.classList.add('is-ready'));
    event.target.querySelectorAll('[data-autoplay-video] video').forEach((video) => {
      video.muted = true;
      play(video);
    });
  });
})();
